import React, { Component } from 'react';
import Validator from 'validatorjs';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';

class AerolineasCargoForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      validator: new Validator({}, this.rules),
    };
  }

  get rules() {
    return {
      CodigoCargo: ['required', 'string', 'min:1', 'max:8'],
      Importe: ['required', 'decimal:6', 'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/'],
    };
  }

  async componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      const validator = this.validate(data);

      this.setState({
        data: { ...data },
        isValid: validator.passes(),
      });
    }
  }

  validate = (data) => {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  };

  handleOnChange = (values) => {
    const data = {
      ...this.state.data,
      ...values,
    };

    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes(),
    });
  };

  handleOnAdd = () => {
    this.props.onAdd(this.state.data);

    this.setState({
      data: {},
      isValid: false,
    });
  };

  render() {
    const rules = this.rules;
    const { isValid, data = {} } = this.state;

    return (
      <>
        <Row>
          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Código cargo"
              name="CodigoCargo"
              placeholder=""
              help=""
              minLength="1"
              maxLength="8"
              rules={rules.CodigoCargo}
              value={data.CodigoCargo}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Importe"
              name="Importe"
              placeholder=""
              help=""
              rules={rules.Importe}
              value={data.Importe}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <p className="text-muted">
              Puedes agregar varios cargos usa el botón "Agregar cargo", los cargos se mostrarán en la tabla de cargos.
            </p>
          </Col>
        </Row>

        <Row>
          <Col className="text-right">
            <Button
              variant="secondary"
              disabled={!isValid}
              onClick={this.handleOnAdd}
            >
              Agregar cargo
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}

export default AerolineasCargoForm;
